module.exports = "https://cdn-web.ertelecom.ru/b2c-domru/frontend/_next/static/images/step1-7855637f3e2734be8b5cc8e9a81646f9.svg";